// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F68_SHGp{display:flex;justify-content:center;gap:var(--space)}`, "",{"version":3,"sources":["webpack://./src/form_components/loading/LoadingSpinner.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,sBAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinner": `F68_SHGp`
};
export default ___CSS_LOADER_EXPORT___;
